import React, { createContext, useContext } from 'react';
import { useCanAccessCropPlanning } from '../hooks/useCanAccessCropPlanning';

interface CropPlanningAccess {
  canAccess: boolean;
  isLoading: boolean;
}

const CropPlanningAccessContext = createContext<CropPlanningAccess>({
  canAccess: false,
  isLoading: true,
});

export const CropPlanningAccessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useCanAccessCropPlanning();
  return (
    <CropPlanningAccessContext.Provider value={value}>
      {children}
    </CropPlanningAccessContext.Provider>
  );
};

export const useCropPlanningAccess = (): CropPlanningAccess => useContext(CropPlanningAccessContext);
